module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "element element-container-single element-bodymatter element-type-chapter element-with-heading",
    attrs: {
      "id": "chapter-005"
    }
  }, [_c('div', {
    staticClass: "heading heading-with-title heading-without-image",
    attrs: {
      "id": "chapter-005-heading"
    }
  }, [_c('div', {
    staticClass: "heading-contents"
  }, [_c('div', {
    staticClass: "title-subtitle-block title-block-title-is-element-number"
  }, [_c('div', {
    staticClass: "element-number-block"
  }), _vm._v(" "), _c('div', {
    staticClass: "title-block"
  }, [_c('h1', {
    staticClass: "title"
  }, [_vm._v("5")])])])])]), _vm._v(" "), _c('div', {
    staticClass: "text",
    attrs: {
      "id": "chapter-005-text"
    }
  }, [_c('p', {
    staticClass: "first first-in-chapter first-full-width"
  }, [_c('span', {
    staticClass: "first-phrase"
  }, [_c('span', {
    staticClass: "drop-cap"
  }, [_c('span', {
    staticClass: "first-punctuation"
  }, [_vm._v("‘")]), _vm._v("F")]), _vm._v("or fucks sake!")]), _vm._v(" is there never a friggin printer in this place "), _c('span', {
    staticClass: "last-word"
  }, [_vm._v("working")]), _vm._v("?’")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("Anna turned to the barked-out comment and shrugged. ‘Don’t ask me. First day and all "), _c('span', {
    staticClass: "last-word"
  }, [_vm._v("that")]), _vm._v(".’")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("‘Cole? Isn’t that right?’ he "), _c('span', {
    staticClass: "last-word"
  }, [_vm._v("asked")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("‘Yeah, Anna "), _c('span', {
    staticClass: "last-word"
  }, [_vm._v("Cole")]), _vm._v(".’")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("‘I’m Richard McKay, Detective Superintendent, your new boss,’ he reached out to shake her hand. His grip strong and dry with surprisingly soft "), _c('span', {
    staticClass: "last-word"
  }, [_vm._v("skin")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("‘Right you’ll be hitting the ground running. Busy time for us as you can see,’ he said indicating with the document in his hand towards the heads down in the quiet bustle of the office, signifying work being done. ‘The daughter of Declan Wells, a former police psychologist, has been "), _c('span', {
    staticClass: "last-word"
  }, [_vm._v("killed")]), _vm._v(".’")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("Anna said, ‘Yeah, I "), _c('span', {
    staticClass: "last-word"
  }, [_vm._v("heard")]), _vm._v(".’")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("‘So you’ll understand that we don’t have time for preliminaries and a welcome party,’ he sighed. ‘Terrible case all together, but we need to make sure we are on the ball and that nothing gets "), _c('span', {
    staticClass: "last-word"
  }, [_vm._v("missed")]), _vm._v(".’")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("‘I’m not looking for hand holding, just let me know what you want me to do,’ Anna "), _c('span', {
    staticClass: "last-word"
  }, [_vm._v("replied")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("He nodded, ‘Settle yourself in and if you need anything ask Holly over there, she’ll tell you who to go to for all that HR "), _c('span', {
    staticClass: "last-word"
  }, [_vm._v("shit")]), _vm._v(".’")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("Anna looked over to the girl with hair dyed a blue-black colour cut in a razor-sharp bob, giving her a hard look, as if she was trying to be intimidating. She wore stylised make up, a cat’s eye flick of dense ebony eyeliner, precise and clean and a ruby red matt lipstick. It was a uniform of sorts. Anna wished she could have enough interest in herself to devise a style, but she had never been good with make-up, preferring to rely on a quick smudge of mascara and a sweep of coral blusher to warm her pale "), _c('span', {
    staticClass: "last-word"
  }, [_vm._v("complexion")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("‘Don’t mind him,’ Holly said, without taking her eyes off her computer screen. ‘He’s a "), _c('span', {
    staticClass: "last-word"
  }, [_vm._v("gobshite")]), _vm._v(".’")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("Anna looked perplexed, unsure of the "), _c('span', {
    staticClass: "last-word"
  }, [_vm._v("colloquialism")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("‘Full of shit? Comprehendy "), _c('span', {
    staticClass: "last-word"
  }, [_vm._v("vous")]), _vm._v("?’")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("‘Yeah, I get it.’ Anna said staring at "), _c('span', {
    staticClass: "last-word"
  }, [_vm._v("her")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("‘We’re all under a lot of stress. Murder of Declan Wells’ daughter has everyone on "), _c('span', {
    staticClass: "last-word"
  }, [_vm._v("edge")]), _vm._v(".’")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("‘I’m sure. One of your own always hurts the most,’ Anna "), _c('span', {
    staticClass: "last-word"
  }, [_vm._v("offered")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("‘Nah she isn’t one of us,’ Holly said finally taking her eyes of the screen giving Anna a once over look. ‘Not that we think that way these days,’ Holly "), _c('span', {
    staticClass: "last-word"
  }, [_vm._v("added")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("‘I thought Declan Wells worked with the "), _c('span', {
    staticClass: "last-word"
  }, [_vm._v("force")]), _vm._v("?’")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("‘Yeah, he used to – forensics section, psychologist. He’s a doctor, not a real cop. Never got his hands dirty on the "), _c('span', {
    staticClass: "last-word"
  }, [_vm._v("job")]), _vm._v(".’")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("Anna absorbed the conversation realising she had considered the murder of Dr Wells’ daughter to be more personal to the force. She found it unsettling when ‘one of your own’ didn’t include your work "), _c('span', {
    staticClass: "last-word"
  }, [_vm._v("colleague")]), _vm._v(".")]), _vm._v(" "), _c('div', {
    staticClass: "ornamental-break ornamental-break-as-image"
  }, [_c('img', {
    staticClass: "inline-ornamental-break",
    attrs: {
      "alt": "",
      "src": "images/break-section-side-screen-fixed.png"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "first first-in-section first-full-width"
  }, [_c('span', {
    staticClass: "first-phrase"
  }, [_c('span', {
    staticClass: "drop-cap"
  }, [_vm._v("T")]), _vm._v("he briefing packs")]), _vm._v(" were passed out during the 10.30 a.m. meeting. Anna flicked through the pages, taking in the format, the highlighted information and the subheadings. The bare bones of the investigation to date reduced to six pages of "), _c('span', {
    staticClass: "last-word"
  }, [_vm._v("print")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("Richard McKay took to the floor and waited for the hush to fall before starting to speak. ‘Right as you all probably know the funeral is today. There will be a significant representation from the force. We are there to pay our respects first and foremost, but of course keep an ear open and your eyes peeled. You never know what could be said at these things or who’s rubber necking.’ He looked around allowing his gaze to fall on Anna, taking a second to place "), _c('span', {
    staticClass: "last-word"
  }, [_vm._v("her")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("‘Anna Cole is here with us on secondment. I’m sure you will all go out of your way to ensure she is welcomed, and show her how we do things over here. Anna if you want to accompany me to the funeral today we can get to know each other on the way to the "), _c('span', {
    staticClass: "last-word"
  }, [_vm._v("church")]), _vm._v(".’")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("‘Sure, sounds "), _c('span', {
    staticClass: "last-word"
  }, [_vm._v("good")]), _vm._v(".’")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("Anna noticed Holly smirk and raise her groomed eyebrow. His easy authority and intense dark eyes were bound to make him desirable even if his manner was "), _c('span', {
    staticClass: "last-word"
  }, [_vm._v("lacking")]), _vm._v(". ")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("Suddenly she felt intensely homesick for the security and familiarity of her own incident room in Cardiff. Here she was the new girl and an outsider to boot. She glanced down at her clear desk, missing the messy disorder of her old one. She even found herself missing Rhys Edwards, her Superintendent, with his acne pocked skin and habit of scratching his beard with a pen. Her colleagues may not have been her best friends but she knew them well and would put herself out for them at every turn, as they would do for her. Now in Belfast she would have no one to rely on, no one to pick up the slack if she needed it, and no one to make her laugh when the day turned "), _c('span', {
    staticClass: "last-word"
  }, [_vm._v("grim")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("‘So, first day then. What do you make of us?’ Richard swung the car into reverse while Anna clicked her seatbelt into "), _c('span', {
    staticClass: "last-word"
  }, [_vm._v("place")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("‘I shall keep my judgment until I have more to go "), _c('span', {
    staticClass: "last-word"
  }, [_vm._v("on")]), _vm._v(".’")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("‘Wise "), _c('span', {
    staticClass: "last-word"
  }, [_vm._v("woman")]), _vm._v(".’")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("He hit the indicator stalk and pulled out on to the rain-washed "), _c('span', {
    staticClass: "last-word"
  }, [_vm._v("road")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("‘So, what brought you to this part of the "), _c('span', {
    staticClass: "last-word"
  }, [_vm._v("world")]), _vm._v("?’")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("Anna paused, unsure of how to answer. ‘Oh, the usual, bored really. Fancied a change of scene. The offer of the secondment came up. I thought now or "), _c('span', {
    staticClass: "last-word"
  }, [_vm._v("never")]), _vm._v(".’")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("He nodded as if to say he understood. ‘Not many from your part of the world over here. Poles, Lithuanians and Romanians yes, but not many "), _c('span', {
    staticClass: "last-word"
  }, [_vm._v("Welsh")]), _vm._v(".’")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("‘I guess you’ve been missing out "), _c('span', {
    staticClass: "last-word"
  }, [_vm._v("then")]), _vm._v(".’")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("They stopped at a pedestrian crossing. A child in a yellow raincoat skipped out and was hastily grabbed back by her mother as the lights turned "), _c('span', {
    staticClass: "last-word"
  }, [_vm._v("amber")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("‘Well, have you had a chance to get up to speed with this Wells girl "), _c('span', {
    staticClass: "last-word"
  }, [_vm._v("case")]), _vm._v("?’")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("‘I’ve read the briefing and looked at the press stuff. No leads yet?’ she "), _c('span', {
    staticClass: "last-word"
  }, [_vm._v("asked")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("‘Nada. You know what it’s like at this stage – it’s all about elimination. The volume of work on this one will be huge with so many wedding guests to talk "), _c('span', {
    staticClass: "last-word"
  }, [_vm._v("to")]), _vm._v(".’")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("‘What about CCTV? I assume the hotel had cameras?’ Anna "), _c('span', {
    staticClass: "last-word"
  }, [_vm._v("said")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("‘Yep, but wouldn’t you know they were down. There was a loss of connection which management had reported over a week ago, but they hadn’t got around to fixing "), _c('span', {
    staticClass: "last-word"
  }, [_vm._v("it")]), _vm._v(".’")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("‘Coincidence or just "), _c('span', {
    staticClass: "last-word"
  }, [_vm._v("convenient")]), _vm._v("?’")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("McKay grimaced, ‘That’s for whoever takes the lead in this case to decide. There’s a lot of pressure riding on this case and my balls are busted if we don’t come up with something double quick. I need a breakthrough and I need it today. Let’s see what we can glean from the funeral "), _c('span', {
    staticClass: "last-word"
  }, [_vm._v("goers")]), _vm._v(".’")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("With the church car park overflowing, like the other mourners, they were forced to park some distance from the church. The black hearse sitting at the front of the church steps still held the oak wood coffin adorned with blooms of pink and white "), _c('span', {
    staticClass: "last-word"
  }, [_vm._v("flowers")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("Anna struggled to keep up with Richard’s long strides. She silently cursed herself for wearing such high heels. She liked to think the added couple of inches made up for her small stature and she had been keen to look well presented on her first day. She’d revert to her usual boots and trousers when she settled "), _c('span', {
    staticClass: "last-word"
  }, [_vm._v("in")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("They left the brightness of the mid-day sun and entered the dark, hushed church. Voices mumbled quietly while an organist played a hymn Anna didn’t recognise. The altar was opulent. A huge arrangement of yellow and pale blue flowers flanked either side of the marble altar table where the priest stood, arms opened and raised as the congregation stood on cue. The choir began to sing and the coffin was carried in. Anna watched as the mother and father followed it up the aisle.  Isabel Wells was dressed in a severe charcoal grey dress walking slowly beside Declan Wells in his "), _c('span', {
    staticClass: "last-word"
  }, [_vm._v("wheelchair")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("Anna was used to religion and the rituals of mourning but the Catholic mass was not familiar to her. Her own family was Baptist. Their church a pale wooden construct, with little adornment and certainly no graphic artwork of the crucified Lord or the periwinkle blue clothed Virgin Mary statue, holding a fat infant "), _c('span', {
    staticClass: "last-word"
  }, [_vm._v("Jesus")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("As the congregation worshiped, kneeled, prayed, stood and sang, Anna allowed herself to drift off in thought. She wondered if Jon had sorted the leaking showerhead; if he had remembered to call the garage about the part for her car, and more importantly, if he missed her. She was still trying to work out her own feelings. The newness of her surroundings, the assault of the accent, the cultural shorthand – all of it was so different, and welcomed. Part of her expected to feel at home in Ireland. To have found herself in the greenness of the countryside, in the din of the city, in the rumble of Belfast. She had always felt something was missing, some unknown part of her she couldn’t identify.  Even with her brief time in the city every conversation was loaded. People weighed her up, assessed her, and she did the same "), _c('span', {
    staticClass: "last-word"
  }, [_vm._v("too")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("She glanced around at the congregation. The family sitting in the front rows, heads lowered as if the weight of grief was pressing down on them. The father, Declan Wells sat at the edge of the pew in his chair. That must surely jar, she thought, always being separate because of the chair. She made a mental note to ask Richard about him. The case notes mentioned he had been in a car bomb. She knew that he was a psychologist working in forensics and had been in the force for many years. He was likely to have been used to dealing with the murder of someone else’s daughter or son and now here he was playing the reverse role. Anna couldn’t imagine it. She wasn’t naive enough to think that she could understand the pain of losing a "), _c('span', {
    staticClass: "last-word"
  }, [_vm._v("child")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("The mother placed her arm around the other daughter who was crying freely, tears streaming like they would never stop with her new husband, Rory, sitting beside her. The case notes said the mother, Isabel, was a lecturer at Queen’s University. She taught in the English faculty. By all accounts, they appeared to be the typical middle class, well-to-do family. Now they sat devastated and "), _c('span', {
    staticClass: "last-word"
  }, [_vm._v("broken")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("The priest was holding the white disc of communion high up, praying for the transformation of the bread into the body of Christ. The choir began to sing again, ‘This is my body broken for you …’ the words lilting and somewhat strangely joyful. Anna watched the congregation mouth the responses, and as they moved in unison to kneel, she caught sight of the new husband, glancing behind, scanning the crowd. Who was he looking "), _c('span', {
    staticClass: "last-word"
  }, [_vm._v("for")]), _vm._v("?")]), _vm._v(" "), _c('div', {
    staticClass: "ornamental-break ornamental-break-as-image"
  }, [_c('img', {
    staticClass: "inline-ornamental-break",
    attrs: {
      "alt": "",
      "src": "images/break-section-side-screen-fixed.png"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "first first-in-section first-full-width"
  }, [_c('i', [_c('span', {
    staticClass: "first-phrase"
  }, [_c('span', {
    staticClass: "drop-cap"
  }, [_vm._v("H")]), _vm._v("e held")]), _vm._v(" the bird in his hand, feeling its heart beat like a snare drum against his palm. The quickest and most efficient way to kill it, without damaging the specimen, is to compress the lungs. He repositioned it, making sure that its body was between his thumb and fingers so that it could gain no purchase with its talons on him. As always, he wanted to cause no impairment to the specimen. An intact creature was always preferable. For a larger bird, he would need to insert a sharp knife under the left wing, straight to the heart, making sure to plug the mouth and the wound instantly. This made him think of the girl, her gaping mouth lying wide in a silent "), _c('span', {
    staticClass: "last-word"
  }, [_vm._v("scream")]), _vm._v(".")])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-01c730ae","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/chapter-005.vue
// module id = 87
// module chunks = 0